var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 13.3741C17.2295 11.2011 22.2426 8.00079 22.2426 8.00079C22.2426 8.00079 23.9672 13.8489 24.0289 16.8025C24.1287 21.5792 18.9202 27.4305 18.9202 27.4305L12.377 24.8592C12.377 24.8592 12.1918 16.8883 15.3047 13.3741Z",
    fill: "url(#paint0_linear_28_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7549 27.3219C13.3892 26.4738 14.2086 25.5789 14.2086 25.5789L17.0796 26.7072C17.0796 26.7072 17.0582 27.9436 17.0614 29.0142C17.0645 30.0849 13.7941 31.2479 13.7941 31.2479C13.7941 31.2479 12.1206 28.1699 12.7549 27.3219Z",
    fill: "url(#paint1_linear_28_27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9202 27.4305C18.9202 27.4305 24.1287 21.5792 24.0289 16.8025C23.9672 13.8489 22.2426 8.00079 22.2426 8.00079C22.2426 8.00079 17.2295 11.2011 15.3047 13.3741C12.1918 16.8883 12.377 24.8592 12.377 24.8592M18.9202 27.4305L12.377 24.8592M18.9202 27.4305L24.3729 29.5733L23.0287 21.2693M12.377 24.8592L6.9244 22.7165L13.214 17.4124M15.4077 13.0906C15.4077 13.0906 16.6314 14.8674 19.3577 15.9388C22.084 17.0102 24.132 16.519 24.132 16.519M14.2086 25.5789C14.2086 25.5789 13.3892 26.4738 12.7549 27.3219C12.1206 28.1699 13.7941 31.2479 13.7941 31.2479C13.7941 31.2479 17.0645 30.0849 17.0614 29.0142C17.0582 27.9436 17.0796 26.7072 17.0796 26.7072L14.2086 25.5789Z",
    stroke: "#14142B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_27",
    x1: 22.2426,
    y1: 8.00079,
    x2: 13.199,
    y2: 31.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_27",
    x1: 22.2426,
    y1: 8.00079,
    x2: 13.199,
    y2: 31.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7834"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.1211,
    height: 28.9577,
    fill: "white",
    transform: "matrix(0.930714 0.365748 -0.341565 0.939858 9.98047 0.590149)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.4b482021e664fba1574208426854bc38.svg";
export { ForwardRef as ReactComponent };